import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SECTORS } from "@/lib/constants";
import Seo from "@/components/Seo";
import CTABand from "@/components/sections/CTABand";

export default function Sectors() {
  return (
    <div data-testid="sectors-page">
      <Seo
        title="Solutions par secteur"
        description="Solutions numériques sur mesure par industrie : restaurants, salons, immigration, immobilier, cliniques, PME — au Québec."
        path="/secteurs"
      />
      <section className="bg-white pt-16 pb-12">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Solutions par secteur</div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-[#0B1F3A] tracking-tighter max-w-3xl text-balance">
            Une expertise <span className="text-[#00B8D9]">par industrie</span>
          </h1>
          <p className="mt-5 text-lg text-[#4B5563] max-w-2xl">
            Chaque secteur a ses propres défis. Nous avons les solutions adaptées à votre réalité.
          </p>
        </div>
      </section>

      <section className="bg-[#F5F7FA] py-16">
        <div className="mx-auto max-w-7xl px-6 md:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SECTORS.map((sec, i) => (
            <motion.div key={sec.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.06 }}>
              <Link to={`/secteurs/${sec.slug}`} data-testid={`sector-card-${sec.slug}`} className="group block h-full bg-white rounded-2xl overflow-hidden border border-gray-200 hover:border-[#00B8D9] hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="aspect-video overflow-hidden">
                  <img src={sec.image} alt={sec.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <h3 className="font-heading font-bold text-xl text-[#0B1F3A] mb-2">{sec.title}</h3>
                  <p className="text-sm text-[#4B5563] mb-3">{sec.caseStudy}</p>
                  <div className="text-sm font-semibold text-[#00B8D9] flex items-center gap-1 group-hover:gap-2 transition-all">
                    Voir les solutions <ArrowRight className="h-4 w-4" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
